export class LogPatternRecordModel {
    firstOccurrenceInTimeWindow;
    pattern;
    count;
    percentage;
    storageSize;
    storageSizeRatioPercentage;
}
//# sourceMappingURL=log-pattern-record.js.map